import React, { useState } from "react";
import { Form, Input, InputNumber, Select, message } from "antd";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import { ADMIN_CREATE_COMPANY } from "../../../constants/api";
import { R_COMPANIES } from "../../../constants/routes";
import ButtonActions from "../../../Components/Buttons/ButtonActions/ButtonActions";
import classes from "./AddCompany.module.scss";

const planOptions = [
  { value: "01", label: "Go" },
  { value: "10", label: "Smart" },
  { value: "11", label: "Go e Smart" },
];

const errorsMap = new Map([
  ["Request failed with status code 409", "Existem campos sem preenchimento."],
  [
    "Request failed with status code 412",
    "Email do super admin já existente na base.",
  ],
  [
    "Request failed with status code 500",
    "Falha ao cadastrar usuário no banco. Tente novamente mais tarde.",
  ],
  [
    "Request failed with status code 523",
    "Falha ao cadastrar empresa no banco. Tente novamente mais tarde.",
  ],
]);

const getCreateCompanyErrorMessage = (error) =>
  errorsMap.get(error?.message) ||
  "Não foi possível cadastrar a empresa. Tente novamente.";

const AddCompany = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isSaving, setIsSaving] = useState(false);

  const planPermission = Form.useWatch("plan_permission", form);
  const showLimitUsersGo =
    planPermission === "01" || planPermission === "11";
  const showLimitUsersSmart =
    planPermission === "10" || planPermission === "11";

  const handleCancel = () => history.push(R_COMPANIES);

  const handleFinish = async (values) => {
    setIsSaving(true);

    const data = {
      company: {
        company_uid: values.company_uid,
        company_name: values.company_name,
        limit_users: values.limit_users || 0,
        limit_users_smart: values.limit_users_smart || 0,
        owned_journeys: values.limit_users_smart || 0,
        plan_permission: values.plan_permission,
      },
      user: {
        user_email: values.email_admin,
        company_uid: values.company_uid,
      },
    };

    try {
      const session = await fetchAuthSession({ forceRefresh: true });
      const userToken = session.tokens?.idToken?.toString();

      await getCurrentUser();
      const resp = await axios.post(ADMIN_CREATE_COMPANY, data, {
        headers: { Authorization: userToken },
      });

      if (resp.status === 200) {
        message.success("Empresa cadastrada com sucesso.");
        history.push(R_COMPANIES);
        return;
      }
    } catch (error) {
      message.error(getCreateCompanyErrorMessage(error));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <h1 className={classes.Title}>Cadastro de Nova Empresa</h1>

      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={handleFinish}
      >
        <div className={classes.FormGrid}>
          <Form.Item
            label="Nome da Empresa"
            name="company_name"
            rules={[{ required: true, message: "Informe o nome da empresa." }]}
          >
            <Input placeholder="nome empresa" />
          </Form.Item>

          <Form.Item
            label="Código da Empresa"
            name="company_uid"
            rules={[
              { required: true, message: "Informe o código da empresa." },
              {
                max: 6,
                message: "O código deve ter no máximo 6 caracteres.",
              },
            ]}
          >
            <Input placeholder="ex.: EMP001" maxLength={6} />
          </Form.Item>

          <Form.Item
            label="Tipo de Plano"
            name="plan_permission"
            rules={[{ required: true, message: "Selecione um tipo de plano." }]}
          >
            <Select
              placeholder="Selecione um tipo de plano"
              options={planOptions}
            />
          </Form.Item>

          <Form.Item
            label="Email Super Admin"
            name="email_admin"
            rules={[
              { required: true, message: "Informe o email do super admin." },
              { type: "email", message: "Informe um email válido." },
            ]}
          >
            <Input placeholder="email" />
          </Form.Item>

          {showLimitUsersGo && (
            <Form.Item
              label="N° Usuários Go"
              name="limit_users"
              rules={[
                { required: true, message: "Informe o número de usuários Go." },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                placeholder="ex: 10"
              />
            </Form.Item>
          )}

          {showLimitUsersSmart && (
            <Form.Item
              label="N° Usuários Smart"
              name="limit_users_smart"
              rules={[
                {
                  required: true,
                  message: "Informe o número de usuários Smart.",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                placeholder="ex: 10"
              />
            </Form.Item>
          )}
        </div>

        <div className={classes.Actions}>
          <ButtonActions
            variant="outline"
            htmlType="button"
            text="Cancelar"
            onClick={handleCancel}
          />
          <ButtonActions
            variant="primary"
            htmlType="submit"
            loading={isSaving}
            text="Adicionar Empresa"
          />
        </div>
      </Form>
    </div>
  );
};

export default AddCompany;